export enum ContractingFileTypeEnum {
  XLS = 'XLS',
  PDF = 'PDF'
}
